import { Box, Divider } from '@mui/material';
import { OATypography } from '../../../components/widgets';
import { HotelJourney } from './HotelTabHelpers/HotelJourney';
import { OtherGuests } from './HotelTabHelpers/OtherGuests';

interface TravellerInfo {
  data: any;
  handleSelected: (val: any) => void;
  selected: string;
}

export default function TravellerInfo(props: TravellerInfo) {
  const { data } = props;
  
  return (
    <Box display='flex' flexDirection='column' gap='24px'>
      <div className='order-view--activity card pb-6'>
        <Box display='flex' justifyContent='space-between' alignItems='center' padding='16px'>
          <OATypography variant='h5'>Primary Guest</OATypography>
        </Box>
        <Divider />
          <Box>
            <HotelJourney data={data} />
          </Box>
      </div>

      {data?.travellers?.length > 0 && <div className='order-view--activity card pb-6'>
        <Box display='flex' justifyContent='space-between' alignItems='center' padding='16px'>
          <OATypography variant='h5'>Other Guests</OATypography>
        </Box>
        <Divider />
          <Box>
            <OtherGuests data={data} />
          </Box>
      </div>}
    </Box>
  );
}
